
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engagements/[slug]",
      function () {
        return require("private-next-pages/engagements/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engagements/[slug]"])
      });
    }
  